import { ReactElement } from "react";
import { SortPayload } from "react-admin";

import { DashboardEventRecordType } from "../../pages/Event/Event.types";

export enum TimeRangeFilterEnum {
  Today = "TODAY",
  Yesterday = "YESTERDAY",
  Next7Days = "NEXT_SEVEN",
  Next30Days = "NEXT_THIRTY",
  Next3Months = "NEXT_THREE_MONTHS",
  LastAndNext15Days = "LAST_AND_NEXT_FIFTEEN",
  Last7Days = "LAST_SEVEN",
  Last30Days = "LAST_THIRTY",
  Last3Months = "LAST_THREE_MONTHS",
  Last6Months = "LAST_SIX_MONTHS",
  ThisYear = "THIS_YEAR",
  ElapsedYear = "YEAR_ELAPSED",
  RemainingYear = "YEAR_REMAINING",
  LastYear = "LAST_YEAR",
  PenultimateYear = "PENULTIMATE_YEAR",
}

export enum GranularityFilterEnum {
  Day = "DAY",
  Week = "WEEK",
  Month = "MONTH",
}

export enum EventCardListContentModeEnum {
  DEFAULT = "default",
  UPCOMING = "upcoming",
}

export type EventCardListPropsType = {
  resourceContext: string;
  perPage?: number;
  title?: string;
  cardsHalfWidth?: boolean;
  cardsExtended?: boolean;
  className?: string;
  filterToolbar?: ReactElement;
  sort?: SortPayload & { order: "ASC" | "DESC" | "asc" | "desc" };
  filterDefaultValues?: { [key: string]: string | boolean | number };
  pagination?: ReactElement;
  mode?: EventCardListContentModeEnum;
  sortModeActive?: boolean;
};

export type EventCardListContentPropsType<EventType = DashboardEventRecordType> = {
  pagination?: ReactElement;
  perPage?: number;
  renderEvent?: (item: EventType) => ReactElement;
};

export type OccursNextDaysEventListFilterType = { period: TimeRangeFilterEnum; show_own: boolean };

export type OccursNextDaysEventListFiltersPropsType = {
  title?: string;
  onResetFilter?: () => void;
  defaultFilter: OccursNextDaysEventListFilterType;
  onFilterChange?: (filter: OccursNextDaysEventListFilterType) => void;
};
